import { RichSelect } from 'common-front/src/designSystem/form/richSelect';
import { useHeavent } from 'common-front/src/hooks/useHeavent';
import { DateTimeService } from 'common/src/services/dateTimeService';
import { useService } from 'common/src/util/dependencies/dependencies';
import { fullName, sortedSlots } from 'common/src/vo/accreditationSlot';
import * as React from 'react';
import { useWorkflowAccreditationsQuery } from '../../../generated/graphqlHooks';
import { WorkflowBox } from '../workflowBox';

export const WorkflowAddAccreditationsStep = () => {
    const {
        translate,
        params: { eventId }
    } = useHeavent();
    const dateTimeService = useService(DateTimeService);
    const { data } = useWorkflowAccreditationsQuery({ eventId });
    const slotsOptions = React.useMemo(
        () =>
            (data.event?.accreditations.nodes ?? []).map((accreditation) => (
                <optgroup key={accreditation.id} label={accreditation.name}>
                    {sortedSlots(accreditation.slots).map((slot) => {
                        const name = fullName(dateTimeService, slot, accreditation.name, {
                            accreditation: { includeNameAtEnd: true }
                        });

                        return (
                            <option key={slot.id} value={slot.id}>
                                {name}
                            </option>
                        );
                    })}
                </optgroup>
            )),
        [data.event]
    );

    return (
        <WorkflowBox
            category={translate('liste_des_accr_02647')}
            icon="badge-check"
            title={translate('les_accr_ditati_19289')}
        >
            <RichSelect
                isSearchVisible={true}
                isSelectAllVisible={true}
                multiple={true}
                name="workflow.data.accreditationsSlotsIds"
            >
                {slotsOptions}
            </RichSelect>
        </WorkflowBox>
    );
};
